// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UJqT","right":"Footer_right__3bbTz","buttons":"Footer_buttons__3qNpT"};